import { StyleSheet, TouchableOpacity, View } from "react-native";
import { Text } from "react-native-paper";

import type { QuestionComponentProps } from "./types";

import { colors, fonts, spacing } from "@/lib/theme";

// MVP: render dropdown options as radio list.
// A proper Picker/Select can replace this later for long option lists.
export function DropdownQuestion({ question, value, onChange, readOnly }: QuestionComponentProps) {
    return (
        <View>
            {question.answerOptions.map((option) => {
                const selected = value === option.value;

                return (
                    <TouchableOpacity
                        key={option.id}
                        activeOpacity={0.8}
                        disabled={readOnly}
                        onPress={() => onChange(option.value)}
                        style={styles.row}
                    >
                        <View style={[styles.radioOuter, selected && styles.radioOuterSelected]}>
                            {selected ? <View style={styles.radioInner} /> : null}
                        </View>
                        <Text style={styles.label}>{option.text}</Text>
                    </TouchableOpacity>
                );
            })}
        </View>
    );
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: spacing.xs
    },
    radioOuter: {
        width: 22,
        height: 22,
        borderRadius: 11,
        borderWidth: 2,
        borderColor: colors.textSecondary,
        alignItems: "center",
        justifyContent: "center",
        marginRight: spacing.sm,
        backgroundColor: colors.surface
    },
    radioOuterSelected: {
        borderColor: colors.teal400
    },
    radioInner: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: colors.teal400
    },
    label: {
        flex: 1,
        fontSize: 15,
        fontFamily: fonts.medium,
        color: colors.textPrimary
    }
});
